<template>
<div>
  <div class="col-md-12 card">
    <div class="card-content row">
      <div class="col-sm-6 col-md-9">
      </div>
      <div class="col-sm-6 col-md-3">
        <p-search @on-search="handleSearch($event)"></p-search>
      </div>
      <div class="col-sm-12">
        <el-table
          class="table-striped"
          :data="tableData"
          :default-sort="{prop: 'createdAt', order: 'descending'}"
          @sort-change="handleSort($event)"
          v-loading="loading"
          style="width: 100%"
        >

          <el-table-column
            prop="reference"
            label="Referência"
            :width="200"
          ></el-table-column>
          <el-table-column
            prop="city"
            label="Município"
            sortable
            width="150"
          ></el-table-column>
          <el-table-column
            prop="numberOfRefigerators"
            label="Geladeiras"
            width="100"
          ></el-table-column>

          <el-table-column
            prop="status"
            label="Qtd. tickets"
            width="100"
          >
            <template slot-scope="scope">
            {{ ticketsCounter ? ticketsCounter[scope.row._id] : '-' }}
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            label="Lâmpadas trocadas"
            width="100"
          >
            <template slot-scope="scope">
            {{ lampsCounter ? lampsCounter[scope.row._id] : '-' }}
            </template>
          </el-table-column>

          <el-table-column
            width="80"
            prop="status"
            label="Info."
            sortable
          >
            <template slot-scope="scope">
            <event-icons :event="scope.row"></event-icons>
            </template>
          </el-table-column>

          <el-table-column
            prop="startDate"
            label="Iniciado em"
            sortable
            :width="120"
          >
            <template slot-scope="scope">
            {{ new Date(scope.row.startDate) | moment('DD/MM/YYYY') }}
            </template>
          </el-table-column>

          <el-table-column label="Ações">
            <template slot-scope="props">
            <div>
              <table-actions-events
                :dropdown="false"
                :event="props.row"
                :show-ranking="showRanking"
                :handle-delete="handleDelete"
                :config="config"
              />
            </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="col-sm-12 text-center">
        <p-pagination
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="pagination.total"
        ></p-pagination>
      </div>
    </div>
  </div>
  <div class="col-sm-12 pagination-info text-right">
    <p class="category"> Mostrando de {{from + 1}} até {{to}} de {{total}} no total.</p>
  </div>
</div>
</template>
<script>
import { Dropdown, DropdownItem, DropdownMenu, Option, Select, Table, TableColumn } from 'element-ui'
import CouchdbClass from 'src/services/CouchdbClass'
import PSearch from 'src/components/UIComponents/Inputs/Search.vue'
import PPagination from 'src/components/UIComponents/Pagination.vue'
import swal from 'sweetalert2'
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import EventIcons from './EventIcons'
import DialogUploadPhotosEvent from 'src/pages/Events/UploadPhotos/DialogUploadPhotosEvent'
import BtnUploadPhotosEvent from 'src/pages/Events/UploadPhotos/BtnUploadPhotosEvent'
import TableActionsEvents from './TableActionsEvents'
import EventActions from './EventActions'

Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Select)
Vue.use(Option)
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)

export default {
  name: 'events-index',
  components: {
    PPagination,
    PSearch,
    EventIcons,
    DialogUploadPhotosEvent,
    BtnUploadPhotosEvent,
    TableActionsEvents,
    EventActions
  },
  data () {
    return {
      dialogPhotos: {
        show: false,
        id: ''
      },
      pagination: {
        perPage: 20,
        currentPage: 1,
        total: 0
      },
      search: {
        query: '',
        fields: ['city', 'reference', 'place']
      },
      count: 0,
      searched: false
    }
  },
  computed: {
    ...mapGetters('events', {
      loading: 'loading',
      ticketsCounter: 'ticketsCounter',
      lampsCounter: 'lampsCounter',
      tableData: 'events'
    }),
    ...mapGetters(['config']),
    to () {
      let highBound = this.from + this.pagination.perPage
      if (this.total < highBound) {
        highBound = this.total
      }
      return highBound
    },
    from () {
      return this.pagination.perPage * (this.pagination.currentPage - 1)
    },
    total () {
      this.pagination.total = this.searched ? this.tableData.length : this.count
      return this.searched ? this.tableData.length : this.count
    },
    currentPage () {
      return this.pagination.currentPage
    }
  },
  watch: {
    currentPage: function (currentPage) {
      this.fetch()
    }
  },
  methods: {
    ...mapActions('events', ['fetchAll', 'fetchViewAll', 'delete', 'fetchTicketsCount', 'fetchLampsCount']),
    ...mapActions('project', {
      fetchProject: 'fetchOne'
    }),
    fetch () {
      this.searched = false
      this.fetchAll({
        limit: this.pagination.perPage,
        skip: this.from,
        sort: {
          field: 'startDate',
          direction: 'desc'
        }
      })
      this.counter()
    },
    fetchSearch () {
      this.searched = true
      this.fetchAll({
        'search': this.search
      })
    },
    handleSearch (query) {
      this.search.query = query
      this.fetchSearch()
    },
    handleSort (sort) {
      this.sort = {
        field: sort.prop,
        direction: sort.order
      }
      this.fetch()
    },
    handleDelete (row) {
      swal({
        title: 'Você tem certeza?',
        text: `Não será possível reverter essa ação!`,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Sim, pode deletar!',
        buttonsStyling: false
      })
        .then(() => {
          this.delete(row.id)
            .then(result => {
              this.$notify({
                message: 'Registro deletado com sucesso.',
                type: 'success'
              })
              this.fetch()
            }).finally(() => {
              this.$router.push({name: 'events.index'})
            })
            .catch(err => console.log(err))
        }).finally(() => {
          this.$router.push({name: 'events.index'})
        })
    },

    showRanking (winnerChoice) {
      return winnerChoice === 'ranking'
    },

    counter () {
      const couchdbAdmin = new CouchdbClass({connection: 'default', collection: 'events'})
      couchdbAdmin.view('count-events-all', 'count-events-all')
        .then(result => {
          this.count = result.rows[0].value
        })
    }
  },

  mounted () {
    if (!this.config) {
      this.fetchProject('config')
    }
    this.fetchTicketsCount()
    this.fetchLampsCount()
    this.fetch()
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/Events/EventsIndex.vue